import Image, { ImageProps } from 'compat/Image';

const NextImage = (props: ImageProps) => <Image {...props} />;

export default NextImage;
